<template>
  <div></div>
</template>

<script>
import { firebaseAuth } from "@/firebase";

export default {
  name: "LogoutView",
  async created() {
    await firebaseAuth.signOut();
    await this.$router.push({ name: 'Login' })
  }
}
</script>
